<!--<div class="row">-->
<table class="table table-dark">
  <thead>
    <tr>
      <th scope="col">#</th>
      <!--<th>ID</th>-->
      <th>Address</th>
      <th>Status</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <th scope="row">1</th>
      <!--<td>{{hatterasLineValuesList[0]?.pairNumber}}</td>-->
      <!--down-->
      <td *ngIf="hatterasLineValuesList[0]?.pairStatus!=1">down for {{transform(hatterasLineValuesList[0]?.downPeriod)}} </td>
      <td *ngIf="hatterasLineValuesList[0]?.pairStatus!=1">down for {{hatterasLineValuesList[0]?.downPeriod}} </td>
      <!--up-->
      <td *ngIf="hatterasLineValuesList[0]?.pairStatus==1">up for {{transform(hatterasLineValuesList[0]?.upPeriod)}} </td>
      <i *ngIf="hatterasLineValuesList[0]" class="fas fa-desktop {{getViewClass(hatterasLineValuesList[0]?.pairStatus)}}"></i>&nbsp;
    </tr>
    <tr>
      <th scope="row">2</th>
      <!--<td>{{hatterasLineValuesList[1]?.pairNumber}}</td>-->
      <!--down-->
    <td *ngIf="hatterasLineValuesList[1]?.pairStatus!=1">down for {{transform(hatterasLineValuesList[0]?.downPeriod)}} </td>
      <!--up-->
    <td *ngIf="hatterasLineValuesList[1]?.pairStatus==1">up for {{transform(hatterasLineValuesList[0]?.upPeriod)}} </td>
      <i *ngIf="hatterasLineValuesList[1]" class="fas fa-desktop {{getViewClass(hatterasLineValuesList[1]?.pairStatus)}}"></i>&nbsp;
    </tr>
    <tr>
      <th scope="row">3</th>
      <!--<td>{{hatterasLineValuesList[2]?.pairNumber}}</td>-->
      <!--down-->
    <td *ngIf="hatterasLineValuesList[2]?.pairStatus!=1">down for {{transform(hatterasLineValuesList[0]?.downPeriod)}} </td>
      <!--up-->
    <td *ngIf="hatterasLineValuesList[2]?.pairStatus==1">up for {{transform(hatterasLineValuesList[0]?.upPeriod)}} </td>
      <i *ngIf="hatterasLineValuesList[2]" class="fas fa-desktop {{getViewClass(hatterasLineValuesList[2]?.pairStatus)}}"></i>&nbsp;
    </tr>

    <tr>
      <th scope="row">4</th>
      <!--<td>{{hatterasLineValuesList[3]?.pairNumber}}</td>-->
      <!--down-->
    <td *ngIf="hatterasLineValuesList[3]?.pairStatus!=1">down for {{transform(hatterasLineValuesList[0]?.downPeriod)}} </td>
      <!--up-->
    <td *ngIf="hatterasLineValuesList[3]?.pairStatus==1">up for {{transform(hatterasLineValuesList[0]?.upPeriod)}} </td>
      <i *ngIf="hatterasLineValuesList[3]" class="fas fa-desktop {{getViewClass(hatterasLineValuesList[3]?.pairStatus)}}"></i>&nbsp;
    </tr>
    <tr>
      <th scope="row">5</th>
      <!--<td>{{hatterasLineValuesList[4]?.pairNumber}}</td>-->
      <!--down-->
    <td *ngIf="hatterasLineValuesList[4]?.pairStatus!=1">down for {{transform(hatterasLineValuesList[0]?.downPeriod)}} </td>
      <!--up-->
    <td *ngIf="hatterasLineValuesList[4]?.pairStatus==1">up for {{transform(hatterasLineValuesList[0]?.upPeriod)}} </td>
      <i *ngIf="hatterasLineValuesList[4]" class="fas fa-desktop {{getViewClass(hatterasLineValuesList[4]?.pairStatus)}}"></i>&nbsp;
    </tr>
    <tr>
      <th scope="row">6</th>
      <!--<td>{{hatterasLineValuesList[5]?.pairNumber}}</td>-->
      <!--down-->
    <td *ngIf="hatterasLineValuesList[5]?.pairStatus!=1">down for {{transform(hatterasLineValuesList[0]?.downPeriod)}} </td>
      <!--up-->
    <td *ngIf="hatterasLineValuesList[5]?.pairStatus==1">up for {{transform(hatterasLineValuesList[0]?.upPeriod)}} </td>
      <i *ngIf="hatterasLineValuesList[5]" class="fas fa-desktop {{getViewClass(hatterasLineValuesList[5]?.pairStatus)}}"></i>&nbsp;
    </tr>

    <tr>
      <th scope="row">7</th>
      <!--<td>{{hatterasLineValuesList[6]?.pairNumber}}</td>-->
      <!--down-->
    <td *ngIf="hatterasLineValuesList[6]?.pairStatus!=1">down for{{transform(hatterasLineValuesList[0]?.downPeriod )}} </td>
      <!--up-->
    <td *ngIf="hatterasLineValuesList[6]?.pairStatus==1">up for {{transform(hatterasLineValuesList[0]?.upPeriod)}} </td>
      <i *ngIf="hatterasLineValuesList[6]" class="fas fa-desktop {{getViewClass(hatterasLineValuesList[6]?.pairStatus)}}"></i>&nbsp;
    </tr>
    <tr>
      <th scope="row">8</th>
      <!--<td>{{hatterasLineValuesList[7]?.pairNumber}}</td>-->
      <!--down-->
    <td *ngIf="hatterasLineValuesList[7]?.pairStatus!=1">down for {{transform(hatterasLineValuesList[0]?.downPeriod)}} </td>
      <!--up-->
    <td *ngIf="hatterasLineValuesList[7]?.pairStatus==1">up for {{transform(hatterasLineValuesList[0]?.upPeriod)}} </td>
      <i *ngIf="hatterasLineValuesList[7]" class="fas fa-desktop {{getViewClass(hatterasLineValuesList[7]?.pairStatus)}}"></i>&nbsp;
    </tr>
    <tr>

  </tbody>
</table>
<!--</div>-->


<div class="row" style="zoom: 100%;">
  <div class="col-12">
    <div class="card">
      <div class="card-header bg-gradient-gray-dark text-orange">
        <i class="fas fa-chart-pie"></i><strong>&nbsp;Performance KPIs :</strong>
      </div>

      <div class="row " style="margin:7px;">
        <div class="col-md-12 col-sm-12">
          <app-line-traffic-digest-graph [lineId]="fullLineInfo.id" [style]="{'width':'100%'}"></app-line-traffic-digest-graph>
        </div>

      </div>
      <div class="row " style="margin:7px;">
        <!--*ngIf="fullLineInfo?.basicInfo!=null"-->
        <!--<app-cc-line-statistics *ngIf="fullLineInfo!=null" [line]="fullLineInfo" [style]="{'width':'100%'}"></app-cc-line-statistics>-->

      </div>
    </div>
  </div>
</div>

<div class="row" style="zoom:100%;">
  <div class="col-12">
    <div class="card">
      <div class="card-header bg-gradient-gray-dark text-orange">
        <i class="fas fa-wrench"></i><strong>&nbsp;Tickets History</strong>&nbsp;

      </div>
      <div class="row" style="margin:7px;">
        <!--*ngIf="fullLineInfo?.basicInfo!=null"-->
        <app-cc-ticket *ngIf="fullLineInfo!=null" [lineQuote]="fullLineInfo?.quoteID" [lineId]="fullLineInfo?.id" [style]="{'width':'100%'}"></app-cc-ticket>
      </div>
      <div class="card-footer bg-gray-light" style="text-align:center">
        <a href="#/line-tickets-full/{{fullLineInfo?.quoteID}}/{{fullLineInfo?.id}}">
          More info <i class="fas fa-arrow-circle-right"></i>
        </a>
      </div>

    </div>
  </div>
</div>

<div class="row" style="zoom:100%;">
  <div class="col-12">
    <div class="card">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <app-map *ngIf="fullLineInfo?.name !=null || fullLineInfo?.name !=undefined"
                   [outerMap]="false" [lineId]="fullLineInfo.id" [lineName]="fullLineInfo?.name"></app-map>
        </div>
      </div>
    </div>
  </div>
</div>

